import React from 'react';
import { formatPriceDollars, formatPriceCents } from '../../../Helpers';
import { presentmentPriceUnformatted } from '../../../multi_currency';

const LineItem = (props) => {
	// const total_price = parseInt(props.price) * props.quantity
	const total_price = parseFloat(formatPriceCents(presentmentPriceUnformatted(props.setCurrency, props.presentmentPrices))) * props.quantity
	return (
		<div className="BoxBuilder_LineItem">
			<span>{props.title}</span>
			<span>{props.size}</span>
			<span>{props.quantity}</span>
			<span>{formatPriceDollars(total_price)}</span>
		</div>
	)
}

export default LineItem;